import React from "react";
import "./doyenAccessHero.css";

const Hero = ({ movedowntopayment }: { movedowntopayment: () => void }) => {
  return (
    <div className="accessHero " style={{ marginTop: "60px" }}>
      <div className="left_div">
        <h6 className="accessText">Doyen Access</h6>
        <h2>
          REALIZE YOUR POTENTIALS WITH <span>Mentorship</span> CUSTOMIZED
        </h2>
        <div className="flex gap-4 sm:items-center">
          <button
            onClick={movedowntopayment}
            className="w-[200px] flex gap-4 text-center"
          >
            Access a Mentor <img src="/images/doyen_access/arrow.png" alt="" />
          </button>
          <h2>JUST FOR YOU</h2>
        </div>
        <p>
          Our platform offers one-on-one expert IT coaching consultations,
          providing you with valuable insights and guidance from industry
          professionals.
        </p>
      </div>
      <div className="right_div">
        <div>
          <p className="text-[14px]">DOYEN ACCESS IN NUMBERS</p>
          <h3 className="text-[28px] font-bold">30-60 Mins</h3>
          <p className="text-[14px]">Approximate duration of one session</p>
        </div>
        <div className="text-[14px]">
          <h2 className="text-[28px] font-bold">
            <span className="line-through text-[#636363]">€130</span> €110
            <span className="text-[14px]">/ Per month</span>
          </h2>
          <p>Basic Access subscription</p>
        </div>
        <div className="review_div">
          <div className="text-[14px]">
            OVER 280+ <b>REVIEWS</b>
            <img src="/images/doyen_access/mentors.png" alt="" />
          </div>
          <button className=" flex w-[220px]" onClick={movedowntopayment}>
            One-on-one Class
            <img src="/images/doyen_access/green_arrow.png" alt="" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
